import { Component, ChangeDetectionStrategy } from '@angular/core';
import { InvitationsListComponent } from '../settings/invitations/invitations-list.component';

@Component({
  selector: 'app-team',
  standalone: true,
  imports: [InvitationsListComponent],
  templateUrl: './team.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './team.component.css',
})
export class TeamComponent {}
